export default __webpack_public_path__ + "static/media/14.5df20d26.svg";